export type TemplateTokens = Record<string, string>;

export function fillTemplate(text: string, tokens: TemplateTokens): string {
  return text.replace(/\{(\w+)\}/g, (match, key: string) => tokens[key] ?? match);
}
